import { getFloorWallSourceProperty, getWallSketchEdgesProperty } from '@pointorama/potree-shared';

/**
 * How a floor exports (DXF / IFC / PDF):
 * - OBJECTS: every exportable object on the floor (as-built);
 * - LAYOUT: wall sketch, opening glyphs and sketch objects (standardised).
 * A standardised floor without walls exports as OBJECTS — the layout would be
 * empty, while its rooms/columns can still be exported.
 */
export type FloorExportMode = 'OBJECTS' | 'LAYOUT';

/** The floor's `floor_wall_source`: ROOMS (as-built) or WALL_SKETCH (standardised). */
export const floorWallSource = (floorId: string): 'ROOMS' | 'WALL_SKETCH' => (getFloorWallSourceProperty(floorId).value === 'ROOMS' ? 'ROOMS' : 'WALL_SKETCH');

// Entering the Wall tab creates an empty wall sketch, so check for edges.
export const floorHasWalls = (children: readonly { identifier: string; type: string }[]): boolean => children.some((c) => c.type === 'WALL_SKETCH' && getWallSketchEdgesProperty(c.identifier).value.length > 0);

export const floorExportMode = (floorId: string, children: readonly { identifier: string; type: string }[]): FloorExportMode => (floorWallSource(floorId) === 'WALL_SKETCH' && floorHasWalls(children) ? 'LAYOUT' : 'OBJECTS');
